export const profileData = {
  name: 'C4sh3r',
  alias: 'Anonymous',
  logo: '/c4sh3r-logo.png',
  title: 'Security Researcher & Software Engineer',
  location: 'Spain',
  email: 'c4sh3r.audit@gmail.com',
  github: process.env.REACT_APP_GITHUB_URL || 'https://github.com/C4sh3R/CTF_HTB',
  githubUsername: 'C4sh3R',
  linkedin: 'https://www.linkedin.com/in/c4sh3r/',
  htbProfile: 'https://app.hackthebox.com/users/2453650',
  
  // HackTheBox Achievements
  htb: {
    machines: [
      { id: 691, name: 'Cobblestone', difficulty: 'insane', url: 'https://labs.hackthebox.com/achievement/machine/2453650/691' },
      { id: 665, name: 'Sorcery', difficulty: 'insane', url: 'https://labs.hackthebox.com/achievement/machine/2453650/665' },
      { id: 778, name: 'Hercules', difficulty: 'insane', url: 'https://labs.hackthebox.com/achievement/machine/2453650/778' },
      { id: 817, name: 'Eloquia', difficulty: 'insane', url: 'https://labs.hackthebox.com/achievement/machine/2453650/817' },
      { id: 754, name: 'DarkZero', difficulty: 'hard', url: 'https://labs.hackthebox.com/achievement/machine/2453650/754' },
      { id: 802, name: 'NanoCorp', difficulty: 'hard', url: 'https://labs.hackthebox.com/achievement/machine/2453650/802' }
    ],
    certifications: [
      { name: 'Puppet', pdfUrl: '/documents/puppet-writeup.pdf' },
      { name: 'Mythical', pdfUrl: '/documents/mythical-writeup.pdf' },
      { name: 'Cybernetics', pdfUrl: '/documents/cybernetics-cert.pdf' }
    ]
  },
  
  about: `Security Researcher y Software Engineer con más de 4 años de experiencia profesional en desarrollo de software, enfocado actualmente en seguridad ofensiva, investigación de vulnerabilidades y explotación de sistemas.

Mi trayectoria como desarrollador me permite abordar la seguridad desde una perspectiva técnica: comprender cómo se diseñan e implementan los sistemas, identificar debilidades en su arquitectura y analizar las condiciones que permiten su explotación.

Mi principal interés no es únicamente utilizar herramientas ofensivas, sino entender qué ocurre detrás de cada vulnerabilidad, investigar su causa raíz y desarrollar técnicas o soluciones adaptadas a cada escenario.

🛡️ OFFENSIVE SECURITY & RED TEAMING

Especial interés en la seguridad de infraestructuras empresariales, entornos Windows y Active Directory.

• Active Directory: Kerberos, NTLM, ADCS, ACL Abuse, delegaciones y relaciones de confianza entre dominios.
• Red Team Operations: Command & Control (C2), movimiento lateral, pivoting, escalada de privilegios y post-explotación.
• Windows Internals: Tokens, privilegios, autenticación, DPAPI y mecanismos internos de seguridad.
• Enterprise Security: Análisis de superficies de ataque en tecnologías como ADFS, SCCM y Exchange.

🔬 VULNERABILITY RESEARCH & EXPLOIT DEVELOPMENT

Investigación independiente de vulnerabilidades, incluyendo el descubrimiento y reporte de fallos de seguridad identificados mediante CVE.

Mis áreas de interés incluyen:
• Binary Exploitation y Memory Corruption.
• Reverse Engineering y análisis de binarios ELF/PE.
• Investigación de vulnerabilidades y Root Cause Analysis.
• Desarrollo de Proofs of Concept (PoC).
• Exploit Development y análisis de mitigaciones.

💻 SOFTWARE ENGINEERING

Experiencia profesional en desarrollo Full-Stack con Java, Spring Boot, SQL, APIs REST y arquitecturas de microservicios.

Combino esta experiencia con investigación de seguridad y formación práctica en laboratorios avanzados de Red Team, simulando escenarios de compromiso de infraestructuras corporativas y ataques de múltiples etapas.

Mi objetivo es seguir especializándome en seguridad ofensiva e investigación de vulnerabilidades, combinando conocimientos de ingeniería de software, sistemas operativos y técnicas avanzadas de explotación.

🎯 Red Teaming · Vulnerability Research · Active Directory Security · Exploit Development · Windows Internals · Reverse Engineering · Offensive Security`,

  experience: [
    {
      id: 1,
      company: 'Alten',
      position: 'Desarrollador de Software',
      location: 'Madrid',
      period: 'jul. 2022 - Actualidad',
      current: true,
      responsibilities: [
        'Desarrollo y mantenimiento de aplicaciones web y multiplataforma utilizando tecnologías como Java, JSF/JSP, HTML, CSS y JavaScript, asegurando funcionalidad y usabilidad',
        'Implementación eficiente de microservicios con Spring Boot y diseño de API REST, facilitando la integración y escalabilidad de sistemas',
        'Gestión de contenedores Docker para optimizar los despliegues, mejorando la eficiencia y la consistencia en diferentes entornos',
        'Aplicación de patrones de diseño MVC para estructurar código de manera eficaz y mantenible, mejorando la arquitectura de las aplicaciones',
        'Realización de pruebas unitarias con JUnit y Mockito para garantizar la calidad y el rendimiento del software',
        'Optimización de procesos internos, contribuyendo a la eficiencia operativa y a la mejora continua',
        'Fortalecimiento de la seguridad en las aplicaciones, asegurando la protección de datos y la confianza de los usuarios',
        'Dominio de tecnologías clave para el desarrollo de software como Java, SQL, Hibernate, JavaScript, XHTML, Spring, HTML, CSS, JSF/JSP, Spring Boot, API REST y Docker'
      ],
      technologies: ['Java', 'Spring Boot', 'Docker', 'API REST', 'JSF/JSP', 'Hibernate', 'JUnit', 'Mockito', 'Maven', 'Jenkins']
    }
  ],

  education: [
    {
      id: 1,
      institution: 'Universidad Internacional de La Rioja (UNIR)',
      degree: 'Grado en Ciberseguridad',
      location: 'Madrid',
      period: '2022 - 2028',
      status: 'En curso',
      description: 'Formación especializada en seguridad informática, análisis de vulnerabilidades, pentesting y protección de sistemas.'
    },
    {
      id: 2,
      institution: 'I.E.S JUAN DE LA CIERVA',
      degree: 'Grado Superior en Desarrollo de Aplicaciones Multiplataforma',
      location: 'Madrid',
      period: '2020 - 2022',
      status: 'Completado',
      description: 'Formación profesional en desarrollo de aplicaciones para múltiples plataformas.'
    }
  ],

  certifications: [
    {
      id: 1,
      name: 'Certificación Profesional Ejército del Aire y del Espacio',
      issuer: 'Ministerio de Defensa - Centro de Informática de Gestión EA',
      date: '2022 - 2025',
      description: 'Certificación oficial como Programador Senior en proyectos de desarrollo Java EE para el Ejército del Aire. Experiencia en sistemas de gestión logística de aeronaves, gestión aeronáutica y calendarios integrales. Dominio de frameworks: Spring, Hibernate, CDI, JPA, PrimeFaces, JSF. Herramientas: Jira, Tomcat, WebLogic, Maven, GitLab, JUnit.',
      downloadable: true,
      filename: 'cert_ea_alten_2022_2025.pdf',
      realPDF: true
    },
    {
      id: 2,
      name: 'SOC 101 - Centro de Operaciones de Seguridad',
      issuer: 'Academia de Ciberseguridad',
      date: '2025-11-20',
      description: 'Certificado de reconocimiento por completar satisfactoriamente el curso de 15 horas académicas en modalidad online. Competencia demostrada en fundamentos del monitoreo, detección, análisis y respuesta ante incidentes de ciberseguridad. Habilidades clave para operar dentro de un Security Operations Center (SOC) moderno, alineado a marcos internacionales como MITRE ATT&CK, NIST y ISO 27035.',
      downloadable: true,
      filename: 'cert_soc101_2025.pdf',
      realPDF: true,
      pdfUrl: '/documents/certification.pdf'
    }
  ],

  skills: {
    // Development
    languages: [
      { name: 'Java', level: 90 },
      { name: 'Python', level: 80 },
      { name: 'JavaScript', level: 85 },
      { name: 'Solidity', level: 70 },
      { name: 'Rust', level: 65 },
      { name: 'Bash/Shell', level: 85 }
    ],
    frameworks: [
      { name: 'Spring Boot', level: 90 },
      { name: 'Foundry', level: 75 },
      { name: 'Hibernate', level: 85 },
      { name: 'React', level: 70 }
    ],
    // Red Team & Pentesting
    redteam: [
      { name: 'Nmap', level: 90 },
      { name: 'Burp Suite', level: 85 },
      { name: 'Metasploit', level: 80 },
      { name: 'Gobuster/ffuf', level: 85 },
      { name: 'BloodHound', level: 75 },
      { name: 'Impacket', level: 80 },
      { name: 'Hashcat/John', level: 85 },
      { name: 'Ghidra', level: 70 }
    ],
    databases: [
      { name: 'Oracle Database', level: 85 },
      { name: 'MySQL', level: 80 },
      { name: 'PostgreSQL', level: 75 }
    ],
    methodologies: ['OWASP Top 10', 'MITRE ATT&CK', 'Pentesting', 'CTF', 'Bug Bounty', 'Agile', 'TDD']
  },

  languages: [
    { name: 'Español', level: 'Nativo' },
    { name: 'Inglés', level: 'Profesional' }
  ],

  asciiArt: `
   ██████╗██╗  ██╗███████╗██╗  ██╗██████╗ ██████╗ 
  ██╔════╝██║  ██║██╔════╝██║  ██║╚════██╗██╔══██╗
  ██║     ███████║███████╗███████║ █████╔╝██████╔╝
  ██║     ╚════██║╚════██║██╔══██║ ╚═══██╗██╔══██╗
  ╚██████╗     ██║███████║██║  ██║██████╔╝██║  ██║
   ╚═════╝     ╚═╝╚══════╝╚═╝  ╚═╝╚═════╝ ╚═╝  ╚═╝
  `
};

export const terminalCommands = {
  help: {
    description: 'Muestra todos los comandos disponibles',
    usage: 'help'
  },
  ls: {
    description: 'Lista las secciones disponibles',
    usage: 'ls [opciones]'
  },
  clear: {
    description: 'Limpia la terminal',
    usage: 'clear'
  },
  about: {
    description: 'Muestra información sobre mí',
    usage: 'about'
  },
  experience: {
    description: 'Muestra mi experiencia laboral',
    usage: 'experience'
  },
  education: {
    description: 'Muestra mi formación académica',
    usage: 'education'
  },
  certifications: {
    description: 'Muestra mis certificaciones',
    usage: 'certifications | certs'
  },
  skills: {
    description: 'Muestra mis habilidades técnicas',
    usage: 'skills'
  },
  contact: {
    description: 'Muestra información de contacto',
    usage: 'contact'
  },
  whoami: {
    description: 'Muestra información básica',
    usage: 'whoami'
  },
  github: {
    description: 'Abre mi perfil de GitHub',
    usage: 'github'
  },
  research: {
    description: 'Abre mi portfolio de vulnerability research',
    usage: 'research | bounty | findings'
  },
  matrix: {
    description: 'Activa el efecto Matrix',
    usage: 'matrix'
  },
  hack: {
    description: 'Simula un proceso de hacking',
    usage: 'hack [target]'
  },
  quote: {
    description: 'Muestra una cita de hacking/tech',
    usage: 'quote'
  },
  lang: {
    description: 'Cambia el idioma (es/en)',
    usage: 'lang [es|en]'
  },
  cat: {
    description: 'Lee el contenido de un archivo',
    usage: 'cat [archivo]'
  },
  web3: {
    description: '🔐 Muestra experiencia en Web3 Security',
    usage: 'web3 | web3 scan'
  },
  ctf: {
    description: '🚩 Inicia el Mini CTF Challenge',
    usage: 'ctf'
  }
};
